import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { AuthProvider } from './features/auth/shared/auth-provider';

@Component({
  imports: [RouterOutlet, ToastModule, ConfirmDialog],
  selector: 'app-root',
  template: `
    <p-toast position="bottom-right"></p-toast>
    <p-confirm-dialog></p-confirm-dialog>
    <router-outlet></router-outlet>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class App implements OnInit {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthProvider);

  ngOnInit(): void {
    // Handle internal login redirect from MiArbolink (?token=xxx&data=base64)
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('tokens');
    const dataBase64 = urlParams.get('data');

    if (token && dataBase64) {
      try {
        // Decode base64 user data (same format as the auth login response)
        const jsonStr = atob(dataBase64);
        const userData = JSON.parse(jsonStr);
        this.auth.notifier.initializeFromRedirect(userData, token);
        // Clean URL without triggering navigation
        window.history.replaceState({}, '', window.location.pathname);
        this.router.navigateByUrl('/viewer');
      } catch (e) {
        console.error('Failed to decode user data from redirect', e);
        window.history.replaceState({}, '', window.location.pathname);
        this.router.navigateByUrl('/login');
      }
      return;
    }
  }
}
